export const SOCIAL_FONT = 'Sofia Sans';

export const socialColors = {
	borderYellow: '#FFF908',
	borderOrange: '#DA600E',
	plate: '#330E07',
	cardGradientTop: '#770700',
	cardGradientBottom: '#320400',
	avatarWell: '#1D0805',
	icon: '#FFD24A',
	levelText: '#3D0F03',
	name: '#FFF7F0',
	label: '#FFF5EB',
	placeholder: 'rgba(255,237,224,0.45)',
} as const;

const glow = (color: string, opacity: number, radius: number) =>
	({
		shadowColor: color,
		shadowOffset: { width: 0, height: 0 },
		shadowOpacity: opacity,
		shadowRadius: radius,
		elevation: Math.round(radius * 0.8),
	}) as const;

export const socialGlow = {
	card: glow('#FF4000', 0.3, 8),
	tabActive: glow('#FF7200', 0.5, 12),
	tabInactive: glow('#FF7200', 0.32, 8),
	searchField: glow('#FF7200', 0.45, 12),
} as const;
